<template>
  <div class="checkout-step__section event-ticket-details">
    <div class="section-heading" style="margin-bottom: 18px;">
      <h2 class="section-heading__title">Elige tu experiencia</h2>
      <p class="section-heading__text">
        Compara las localidades y lo que incluye cada entrada.
      </p>
    </div>

    <div v-if="eventType == 2 && eventTickets.length == 0" class="shell-empty-state">
      Para adquirir este evento debes ser invitado por un promotor, auspiciante o tener un código de acceso.
    </div>

    <div v-else class="checkout-step__table">
      <div class="ticket-tier-grid">
        <article
          v-for="(eventTicket, index) in eventTickets"
          :key="index"
          :class="['ticket-tier-card', { 'is-courtesy': eventTicket.is_courtesy }]"
        >
          <div class="ticket-tier-card__top">
            <div>
              <h3 class="ticket-tier-card__title">{{ eventTicket.name }}</h3>
            </div>

            <div class="ticket-tier-card__price">
              <span v-if="eventTicket.is_courtesy">Cortesía</span>
              <span v-else>${{ eventTicket.price }}</span>
            </div>
          </div>

          <p class="ticket-tier-card__description">
            {{ eventTicket.description || 'Cupos limitados con validación en tiempo real.' }}
          </p>

          <div class="ticket-tier-card__footer">
            <span>{{ eventTicket.is_courtesy ? 'Acceso validado por invitación' : 'Compra directa disponible' }}</span>
            <span v-if="eventTicket.max_quantity">Máx. {{ eventTicket.max_quantity }} por orden</span>
          </div>
        </article>
      </div>

      <p class="checkout-step__inline-note">
        Disponibilidad y precio sujetos a confirmación al seleccionar tus entradas.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventViewDetail',

  props: {
    updatesProp: {
      type: Object,
    },
    eventTickets: {
      type: Array,
    },
    eventType: {
      required: true,
    },
  },
}
</script>

<style scoped>
.event-ticket-details .section-heading__title {
  font-size: clamp(1.5rem, 2.4vw, 2rem);
  line-height: 1.2;
  letter-spacing: -0.035em;
  margin: 0 0 8px;
}
.event-ticket-details .section-heading__text {
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
}
.event-ticket-details .ticket-tier-grid {
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: 16px;
}
.event-ticket-details .ticket-tier-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 16px;
  padding: 24px;
  border-radius: 24px;
}
.event-ticket-details .ticket-tier-card__top {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  min-height: 0;
}
.event-ticket-details .ticket-tier-card__title {
  margin: 0;
  font-size: 1.2rem;
  line-height: 1.3 !important;
  letter-spacing: -0.025em;
  overflow-wrap: anywhere;
}
.event-ticket-details .ticket-tier-card__price {
  font-size: 1.6rem;
  line-height: 1.15;
  letter-spacing: -0.035em;
}
.event-ticket-details .ticket-tier-card__description {
  margin: 0;
  min-height: 0;
  font-size: 0.9rem;
  line-height: 1.65;
}
.event-ticket-details .ticket-tier-card__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-top: auto;
  padding-top: 14px;
  font-size: 0.75rem;
  line-height: 1.5;
}
.event-ticket-details .checkout-step__inline-note {
  margin-top: 16px;
  font-size: 0.8rem;
  line-height: 1.5;
}
</style>
